module.exports = __webpack_public_path__ + "static/media/BB.d35efe6b.svg";